const woosmapPublicKey = "woos-c1822d2f-e8ad-3603-859d-70d7afa385b4";

const mobileBreakPoint = 768;

const userLocationIconOptions: woosmap.map.Icon = {
  url: "https://images.woosmap.com/user-position.png",
  scaledSize: {
    height: 32,
    width: 32,
  },
}
const mapPaddings: { [key: string]: woosmap.map.Padding } = {
  mobile: { left: 50, right: 50, top: 100, bottom: 550 },
  full: { left: 450, right: 50, top: 100, bottom: 50 },
};

const storesStyle: woosmap.map.Style = {
  breakPoint: 11,
  rules: [],
  default: {
    color: "#e61d2a",
    size: 11,
    minSize: 1,
    icon: {
      url:
        "https://woosmap-indoor-img.s3.amazonaws.com/lpernelle/JO_2024/venue.png",
      anchor: { x: 38, y: 76 },
      size: {
        height: 512,
        width: 512
      },
      scaledSize: {
        height: 76,
        width: 76
      }
    },
    selectedIcon: {
      url: "https://woosmap-indoor-img.s3.amazonaws.com/lpernelle/JO_2024/venue.png",
      anchor: { x: 51, y: 98 },
      size: {
        height: 512,
        width: 512
      },
      scaledSize: {
        height: 102,
        width: 102
      }
    },
  },
};
const mapOptions: woosmap.map.MapOptions = {
  center: { lat: 46.2, lng: 3.2 },
  zoom: 6,
  styles: [
    {
      featureType: "point_of_interest",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
  ],
  gestureHandling: "greedy",
};


export default {
  mapOptions: mapOptions,
  storesStyle: storesStyle,
  mapPaddings: mapPaddings,
  mobileBreakPoint: mobileBreakPoint,
  woosmapPublicKey: woosmapPublicKey,
  userLocationIconOptions: userLocationIconOptions,
}
